import { render, staticRenderFns } from "./SetMonthlyGoalInsight.vue?vue&type=template&id=9b430b60&scoped=true"
import script from "./SetMonthlyGoalInsight.vue?vue&type=script&lang=js"
export * from "./SetMonthlyGoalInsight.vue?vue&type=script&lang=js"
import style0 from "./SetMonthlyGoalInsight.vue?vue&type=style&index=0&id=9b430b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b430b60",
  null
  
)

export default component.exports